import { CustomFieldConditionEnum } from './custom-field-condition.enum';

interface ConditionType {
  id: CustomFieldConditionEnum;
  label: string;
}

export class CustomFieldConditionsUtils {
  /**
   * Map<string, string[]>
   *  - key: the custom field type
   *  - value: the allowed conditions
   */
  conditionsByCustomFieldTypeMap = new Map<string, ConditionType[]>();
  booleanItems = [];
  operatorsExcluded: CustomFieldConditionEnum[] = [];

  constructor($translate: { instant: any }, operatorsExcluded: CustomFieldConditionEnum[] = []) {
    this.operatorsExcluded = operatorsExcluded;
    this.booleanItems = [
      { id: true, label: $translate.instant('yes') },
      { id: false, label: $translate.instant('no') },
    ];

    const isNullItem = {
      id: CustomFieldConditionEnum.IS_NULL,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/is_null'),
    };

    const isNotNullItem = {
      id: CustomFieldConditionEnum.IS_NOT_NULL,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/is_not_null'),
    };

    const containsItem = {
      id: CustomFieldConditionEnum.CONTAINS,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/contains'),
    };

    const doesNotContainItem = {
      id: CustomFieldConditionEnum.DOES_NOT_CONTAIN,
      label: $translate.instant(
        'parameters/quick_replies/details/details/conditions_on_custom_fields/does_not_contain'
      ),
    };

    const biggerThanItem = {
      id: CustomFieldConditionEnum.BIGGER_THAN,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/bigger_than'),
    };

    const lowerThanItem = {
      id: CustomFieldConditionEnum.LOWER_THAN,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/lower_than'),
    };

    const equalItem = {
      id: CustomFieldConditionEnum.EQUAL,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/equal'),
    };

    const notEqualItem = {
      id: CustomFieldConditionEnum.NOT_EQUAL,
      label: $translate.instant('parameters/quick_replies/details/details/conditions_on_custom_fields/not_equal'),
    };

    this.assignOperatorsToConditionType('integer', [
      isNotNullItem,
      isNullItem,
      containsItem,
      doesNotContainItem,
      biggerThanItem,
      lowerThanItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('float', [
      isNotNullItem,
      isNullItem,
      containsItem,
      doesNotContainItem,
      biggerThanItem,
      lowerThanItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('boolean', [isNotNullItem, isNullItem, equalItem, notEqualItem]);

    this.assignOperatorsToConditionType('enum', [isNotNullItem, isNullItem, equalItem, notEqualItem]);

    this.assignOperatorsToConditionType('string', [
      isNotNullItem,
      isNullItem,
      containsItem,
      doesNotContainItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('url', [
      isNotNullItem,
      isNullItem,
      containsItem,
      doesNotContainItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('phone', [isNotNullItem, isNullItem, equalItem, notEqualItem]);

    this.assignOperatorsToConditionType('email', [
      isNotNullItem,
      isNullItem,
      containsItem,
      doesNotContainItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('datetime', [
      isNotNullItem,
      isNullItem,
      biggerThanItem,
      lowerThanItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('date', [
      isNotNullItem,
      isNullItem,
      biggerThanItem,
      lowerThanItem,
      equalItem,
      notEqualItem,
    ]);

    this.assignOperatorsToConditionType('multipicklist', [containsItem]);
  }

  private assignOperatorsToConditionType(conditionType, operators: ConditionType[]) {
    this.conditionsByCustomFieldTypeMap.set(
      conditionType,
      operators.filter(({ id }) => !this.operatorsExcluded.includes(id))
    );
  }
}
